import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { APIService } from '../../api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TodayTommorowPipe } from '../../pipe/todayTommorow/today-tommorow.pipe'; // Import pipe

@Component({
    selector: 'app-all-task-report',
    templateUrl: './all-task-report.component.html',
    styleUrls: ['./all-task-report.component.scss'],
    providers: [TodayTommorowPipe] // Add Provider
})
export class AllTaskReportComponent implements OnInit {
    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
    }
    @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
        this.dataSource.paginator = value;
    }

    displayedColumns: string[] = ['Task', 'Detail', 'FromUserName', 'ToUserName', 'CreatedDT', 'ExpCompletionDT', 'Priority'];
    dataSource = new MatTableDataSource();
    exportToExcel: any[] = []; // For Excel Export

    // Data & Filters
    taskData: any[] = [];
    filteredData: any[] = [];
    userList: any[] = [];
    jarvisData: any;
    agencyData: any;

    // Filter Models
    selectedStatus: string = 'Pending'; // Default
    selectedAssigner: string = '0';
    selectedAssignee: string = '0';

    // Date/Month Filter
    months: any[] = [];
    selectedMonth: any;
    selectedMonthID: any;
    selectedYear: any;
    showDate: boolean = false;
    selectedDate: Date = new Date();
    maxDT: Date = new Date();
    minDT: Date = new Date(this.maxDT.getFullYear(), this.maxDT.getMonth(), -(this.maxDT.getDate() - 1));

    constructor(
        private router: Router,
        private commonService: CommonService,
        private apiService: APIService,
        private todayTommorowPipe: TodayTommorowPipe // Inject Pipe
    ) { }

    ngOnInit(): void {
        // Get User List
        let users = this.apiService.getCookie('J');
        if (users) {
            this.userList = JSON.parse(users);
        }

        // Get Jarvis Data
        let jarvis: any = this.apiService.getCookie('Jarvis');
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
        }

        // Get Agency Data
        let agencyData = this.apiService.getCookie('M');
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
        }

        // Date Setup
        this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
        if (this.months.length > 0) {
            this.selectedMonth = this.months[this.months.length - 1].number;
            this.selectedYear = this.months[this.months.length - 1].year;
            this.selectedMonthID = this.months.sort((a, b) => b.id - a.id)[0].id;
        }
        if (!this.checkAllTaskAccess()) {
            this.router.navigate(['/Tasks']);
        }

        this.getData();
    }

    //export to excel
    tableToExcel = (function () {
        var uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
            , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

        return function (table: any, name: string, fileName: any) {
            if (!table.nodeType) table = table
            var ctx = { worksheet: name || 'Worksheet', table: table }
            var link = document.createElement("a");
            link.download = fileName || 'download.xls';
            link.href = uri + base64(format(template, ctx));
            link.click();
        }
    })()

    getData() {
        let data = [{
            month: this.selectedMonth,
            year: this.selectedYear,
            getType: 'ALL'
        }];

        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'rpt_TSK_History',
            moduleID: 28,
            data: JSON.stringify(data),
        }];

        this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }

    successResp(res: any) {
        if (!res.error && res.updatePackage) {
            let responseData = JSON.parse(res.updatePackage);
            if (responseData.Table && responseData.Table[0].ErrCode == -1) {
                this.taskData = responseData.Table1;

                // Process Data
                this.taskData.forEach((element: any) => {
                    // pre-calculate colors using getDateColor
                    element.Color = this.getDateColor(element.ExpCompletionDT); // For Due on (kept as element.color to match)

                    element.CreatedDT = new Date(element.CreatedDT).customFormat("#DD#-#MMM#-#YY#");
                    element.ExpCompletionDT = element.ExpCompletionDT ? new Date(element.ExpCompletionDT).customFormat("#DD#-#MMM#-#YY#") : '';
                    element.DoneDT = element.DoneDT ? new Date(element.DoneDT).customFormat("#DD#-#MMM#-#YY#") : '';
                    element.Priority = element.Priority == 0 ? 'High' : element.Priority == 1 ? 'Normal' : element.Priority == 2 ? 'Low' : '';

                    // Map FromUserName (Assigner)
                    if (!element.FromUserName) {
                        let creator = this.userList.find(u => u.UserID == element.CreatedUserID);
                        element.FromUserName = creator ? creator.Name : '';
                    }
                });

                this.applyFilters();
            } else {
                // Handle error or empty
                this.taskData = [];
                this.dataSource.data = [];
            }
        }
    }

    failureResp(res: any) {
        console.error(res);
    }

    applyFilters() {
        let temp = this.taskData;

        // 1. Status Filter
        if (this.selectedStatus === 'Pending') {
            temp = temp.filter((x: any) => x.StatusID != 3);
        } else if (this.selectedStatus === 'Completed') {
            temp = temp.filter((x: any) => x.StatusID == 3);
        }

        // 2. Assigner Filter (FromUserID)
        if (this.selectedAssigner !== '0') {
            temp = temp.filter((x: any) => x.FromUserID == this.selectedAssigner);
        }

        // 3. Assignee Filter (ToUserID)
        if (this.selectedAssignee !== '0') {
            temp = temp.filter((x: any) => x.ToUserID == this.selectedAssignee);
        }

        // 4. Date Filter (Only if Completed)
        if(this.selectedStatus === 'Completed') {
            temp = temp.filter((x: any) => {
                let createdDT = x.CreatedDT ? new Date(x.CreatedDT) : null;
                let month = Number(createdDT?.getMonth()) + 1;
                let year = createdDT?.getFullYear();
                return month == this.selectedMonth && year == this.selectedYear;
            });
        }
        if (this.selectedStatus === 'Completed' && this.showDate) {
            // Filter by selectedDate
            let selDateStr = new Date(this.selectedDate).customFormat('#DD#-#MMM#-#YY#');
            // Filter by CreatedDT? or DoneDT?
            // Task History `fn_ChangeDate` filters by `CreatedDT`.
            temp = temp.filter((x: any) => x.CreatedDT == selDateStr);
        }

        this.filteredData = temp;
        this.dataSource.data = this.filteredData;
        this.exportToExcel = this.filteredData;

        // Update Displayed Columns based on Status
        if (this.selectedStatus === 'Pending') {
            this.displayedColumns = ['Task', 'Detail', 'FromUserName', 'ToUserName', 'CreatedDT', 'ExpCompletionDT', 'Priority'];
        } else {
             // Completed
             this.displayedColumns = ['Task', 'Detail', 'FromUserName', 'ToUserName', 'CreatedDT', 'ExpCompletionDT', 'DoneDT', 'Priority'];
        }

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    compareDates(exp: string, done: string): number {
        // Expecting "DD-MMM-YY" strings
        // Convert to Date objects
        let d1 = new Date(exp);
        let d2 = new Date(done);
        return d1.getTime() - d2.getTime();
    }

    getDateColor(dateStr: string): string {
        if (!dateStr) return '';
        let todayStr = new Date().customFormat("#DD#-#MMM#-#YY#");
        // dateStr is already formatted as #DD#-#MMM#-#YY# in successResp
        // But we need to compare dates.
        // Let's assume dateStr is "DD-MMM-YY".
        
        let d = new Date(dateStr);
        let t = new Date(todayStr);

        // We can compare strings if format allows, but better to compare dates.
        // Since customFormat might return string that Date() constructor doesn't like?
        // Actually earlier comparisons used new Date(todayStr) < new Date(expStr)
        
        if (todayStr == dateStr) {
            return 'orangeText';
        } else if (t < d) {
             // Today is BEFORE Date -> Future -> Green
            return 'greenText';
        } else {
            // Today is AFTER Date -> Past -> Red
            return 'redText';
        }
    }

    // Events
    onStatusChange() {
        if (this.selectedStatus === 'Completed') {
            // Ensure month is selected
            if (!this.selectedMonth) {
                if (this.months.length > 0) {
                    this.selectedMonth = this.months[this.months.length - 1].number;
                    this.selectedYear = this.months[this.months.length - 1].year;
                }
            }
        }
        this.applyFilters();
    }

    onAssignerChange() {
        this.applyFilters();
    }

    onAssigneeChange() {
        this.applyFilters();
    }

    onMonthChange() {
        // Find year from month list
        let m = this.months.find((x: any) => x.id == this.selectedMonthID);

        if (m) {
            this.selectedYear = m.year;
            this.selectedMonth = m.number;
        }
        this.applyFilters();
    }

    toggleDateFilter() {
        this.applyFilters();
    }

    applySearch(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    returnToTasks() {
        this.router.navigate(['/Tasks']);
    }

    checkAllTaskAccess() {
        // Function to get cookie from localStorage
        function getLocalStorageCookie(name: string) {
            try {
                const value = localStorage.getItem(name);
                return value ? JSON.parse(value) : null;
            } catch (e) {
                console.error('Error getting cookie from localStorage:', e);
                return null;
            }
        }

        // Get M cookie from localStorage
        const mCookie = getLocalStorageCookie('M');
        if (!mCookie || !Array.isArray(mCookie)) return false;

        // Extract showAllTaskBit from M cookie
        const showAllTaskBit = mCookie[0]?.AllowOrgTasks || false;
        if (!showAllTaskBit) return false;

        // Extract UserID and AdminUserID from M cookie
        const currentUserID = this.jarvisData[0]?.UserID;
        const adminUserID = mCookie[0]?.AdminUserID;

        // Check if user is admin
        const isAdmin = currentUserID === adminUserID;

        // Get J cookie from localStorage
        const jCookie = getLocalStorageCookie('J');
        if (!jCookie || !Array.isArray(jCookie)) return false;

        // Find current user in J cookie
        const currentUser = jCookie.find((user: any) => user.UserID === currentUserID);
        if (!currentUser) return false;

        // Check if user is super user (has all CRM, B2B, and ERP rights)
        const isSuperUser = (currentUser.PropEntry && currentUser.PropEdit && currentUser.CstrEntry && currentUser.CstrEdit && currentUser.QuoteEntry && currentUser.QuoteEdit && currentUser.ApprQot && currentUser.SOEntry && currentUser.SOEdit && currentUser.ApprSO && currentUser.SOStatusUpdate && currentUser.InvoiceEntry && currentUser.InvoiceEdit && currentUser.ApprInv && currentUser.CtrcEntry && currentUser.CtrcEdit && currentUser.CtrcStatusUpdates && currentUser.PropViewTypeID === 1 && currentUser.CstrViewTypeID === 1 && currentUser.InvoiceView && currentUser.ConnEntry && currentUser.FeedEntry && currentUser.Accts && currentUser.AcctsVchrEntry && currentUser.AcctsCfg && currentUser.Inv && currentUser.InvXns && currentUser.InvMstrs && currentUser.InvRpts && currentUser.InvCfg && currentUser.Prd && currentUser.PrdRpts && currentUser.PrdCfg && currentUser.SplrEntry && currentUser.SplrEdit && currentUser.POEntry && currentUser.POView && currentUser.ApprPurch && currentUser.InvRateView && currentUser.SplrInvoiceViewTypeID && currentUser.SplrInvoiceEntry && currentUser.SplrInvoiceEdit);

        // Return true if showAllTaskBit is true AND (user is admin OR user is super user)
        return showAllTaskBit && (isAdmin || isSuperUser);
    }

    //export to excel
    exportToExcelTasks() {
        var html = "";
        //Title
        html += "<table><tr>";
        html += "<th style='text-align: left;'>Task Records</th>"
        html += "</table></tr>";
        html += "<table><tr></table></tr>";
        html += "<table><tr>";
        html += "</table></tr>";
        
        // Header Info
        // html += "<p>Month :" + this.selectedMonth + "</p>" // Month is only relevant for Completed
        if (this.selectedStatus === 'Completed') {
             // Find display month
            let m = this.months.find(x => x.number == this.selectedMonth && x.year == this.selectedYear);
            if(m) html += "<p>Month :" + m.display + "</p>";

            if (this.showDate == true) {
                let selectedDate = new Date(this.selectedDate).customFormat("#DD#-#MMM#-#YY#");
                html += "<p>Date:" + selectedDate + "</p>"
            }
        }
        
        html += "<p>Filter :" + this.selectedStatus + "</p>"
        html += "<table><tr>";
        var strHeader = ""
        strHeader += "<th style='text-align: left;'>Assigned on</th>";
        strHeader += "<th style='text-align: left;'>Task</th>";
        strHeader += "<th style='text-align: left;'>Description</th>";
        strHeader += "<th style='text-align: left;'>Assigner</th>";
        strHeader += "<th style='text-align: left;'>Assignee</th>";
        strHeader += "<th style='text-align: left;'>Expected on</th>";
        if (this.selectedStatus === 'Completed') {
            strHeader += "<th style='text-align: left;'>Completed on</th>";
        }
        strHeader += "<th style='text-align: left;'>Priority</th>";

        strHeader += "</tr>"
        html += strHeader;
        var body = "";
        this.exportToExcel.forEach((item: any, key: any) => {
            body += "<tr>";
            body += "<td style='text-align: left;'>" + (item.CreatedDT ? this.todayTommorowPipe.transform(item.CreatedDT) : '-') + "</td>";
            body += "<td style='text-align: left;'>" + item.Task + "</td>";
            body += "<td style='text-align: left;'>" + (item.Detail ? item.Detail : '-') + "</td>";
            body += "<td style='text-align: left;'>" + item.FromUserName + "</td>";
            body += "<td style='text-align: left;'>" + item.ToUserName + "</td>";
            body += "<td style='text-align: left;'>" + (item.ExpCompletionDT ? this.todayTommorowPipe.transform(item.ExpCompletionDT) : '-') + "</td>";
            if (this.selectedStatus === 'Completed') {
                body += "<td style='text-align: left;'>" + (item.DoneDT ? this.todayTommorowPipe.transform(item.DoneDT) : '-') + "</td>";
            }
            body += "<td style='text-align: left;'>" + item.Priority + "</td>";
            body += "</tr>";
        })
        html += body;
        html += "</table>";
        this.tableToExcel(html, 'Task Records', 'Task Records');
    }

}
